import { ReactNode } from 'react';
import { Platform, StyleSheet } from 'react-native';
import MarkdownComponent from 'react-native-markdown-display';
import { useTheme } from '../../lib/useTheme';
import { renderRules } from './renderRules';

export const Markdown = ({
  children,
  textColor,
  styles,
}: {
  children: ReactNode;
  textColor?: string;
  styles?: StyleSheet.NamedStyles<any>;
}) => {
  const theme = useTheme();

  const defaultStyles = StyleSheet.create({
    root: {
      color: textColor || theme.neutral[300],
      fontFamily: 'Bozon',
    },
    view: {
      color: textColor || theme.neutral[300],
      fontFamily: 'Bozon',
    },
    codeBlock: {
      borderWidth: 1,
      borderColor: '#CCCCCC',
      backgroundColor: '#f5f5f5',
      padding: 10,
      borderRadius: 4,
      color: textColor || theme.neutral[300],
    },
    codeInline: {
      borderWidth: 1,
      borderColor: '#CCCCCC',
      backgroundColor: '#f5f5f5',
      padding: 10,
      borderRadius: 4,
      color: textColor || theme.neutral[300],
    },
    del: {
      backgroundColor: '#000000',
    },
    em: {
      fontStyle: 'italic',
    },
    headingContainer: {
      flexDirection: 'row',
    },
    heading: {
      color: textColor || theme.neutral[300],
    },
    heading1: {
      fontSize: 32,
    },
    heading2: {
      fontSize: 24,
    },
    heading3: {
      fontSize: 18,
    },
    heading4: {
      fontSize: 16,
    },
    heading5: {
      fontSize: 13,
    },
    heading6: {
      fontSize: 11,
    },
    hr: {
      backgroundColor: textColor || theme.neutral[300],
      height: 1,
    },
    br: {
      backgroundColor: textColor || theme.neutral[300],
      height: 1,
    },
    blockquote: {
      paddingHorizontal: 20,
      paddingVertical: 10,
      margin: 20,
      backgroundColor: textColor || theme.neutral[300],
    },
    inlineCode: {
      borderRadius: 3,
      borderWidth: 1,
      fontFamily: 'Courier',
      fontWeight: 'bold',
    },
    textarea: {
      color: textColor || textColor || theme.neutral[300],
    },
    list: {},
    listItem: {
      flex: 1,
      flexWrap: 'wrap',
      // backgroundColor: 'green',
    },
    bullet_list: {
      flex: 1,
      flexWrap: 'wrap',
      color: textColor || theme.neutral[300],
    },
    listUnordered: {},

    listUnorderedItem: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },

    listUnorderedItemIcon: {
      marginLeft: 10,
      marginRight: 10,
      ...Platform.select({
        ['ios']: {
          lineHeight: 36,
        },
        ['android']: {
          lineHeight: 30,
        },
      }),
    },
    listUnorderedItemText: {
      fontSize: 20,
      lineHeight: 20,
    },

    listOrdered: {},
    listOrderedItem: {
      flexDirection: 'row',
    },
    listOrderedItemIcon: {
      marginLeft: 10,
      marginRight: 10,
      ...Platform.select({
        ['ios']: {
          lineHeight: 36,
        },
        ['android']: {
          lineHeight: 30,
        },
      }),
    },
    listOrderedItemText: {
      fontWeight: 'bold',
      lineHeight: 20,
    },
    paragraph: {
      marginTop: 10,
      marginBottom: 10,
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      color: textColor || theme.neutral[300],
    },
    hardbreak: {
      width: '100%',
      height: 1,
    },
    softbreak: {
      width: '100%',
      height: 1,
    },
    strong: {
      fontWeight: 'bold',
    },
    table: {
      borderWidth: 1,
      borderColor: '#000000',
      borderRadius: 3,
      color: textColor || theme.neutral[300],
    },
    tableHeader: {},
    tableHeaderCell: {
      flex: 1,
      color: textColor || theme.neutral[300],
      padding: 5,
      // backgroundColor: 'green',
    },
    tableRow: {
      borderBottomWidth: 1,
      borderColor: textColor || theme.neutral[300],
      flexDirection: 'row',
    },
    tableRowCell: {
      flex: 1,
      padding: 5,
      color: textColor || theme.neutral[300],
    },
    text: {
      color: textColor || theme.neutral[300],
      fontFamily: 'Bozon',
    },
    link: {
      textDecorationLine: 'underline',
      color: textColor || theme.neutral[300],
      fontFamily: 'Bozon',
    },
    strikethrough: {
      textDecorationLine: 'line-through',
    },
    blocklink: {
      flex: 1,
      borderColor: textColor || theme.neutral[300],
      borderBottomWidth: 1,
    },
    u: {
      borderColor: '#000000',
      borderBottomWidth: 1,
    },
    image: {
      flex: 1,
    },
  });
  return (
    <MarkdownComponent
      style={{ ...defaultStyles, ...styles }}
      rules={renderRules}
    >
      {children}
    </MarkdownComponent>
  );
};
